export const mapRecipesToMagistralPayload = (recipes) => {
  const productsList = recipes.flatMap((recipe) => {
    const magistralFinished = recipe.products?.magistralFinished || [];

    return magistralFinished.map((product) => ({
      magistral_prepared_id: product.id,
      quantity: Number(product.quantity),
      recipe_id: recipe.id,
      discount: {
        type: "PERCENTAGE",
        value: Number(product.discount_percent || 0)
      }
    }));
  });

  return { products: productsList };
};